// client/src/components/HomeScreen.js
//import { useFetch } from '../hooks/useFetch';
import {useMe} from '../lib/OrgProvider';
// /me is now fetched by OrgProvider at the App level. This screen
// just reads the cached result via useMe(). Loading and error
// states are handled by the provider, so we don't repeat them here.

export function HomeScreen() {
  /*
  const { data: me, loading, error } = useFetch('/me');

  if (loading) {
    return <div style={{ padding: 20, fontFamily: 'sans-serif' }}>Loading…</div>;
  }

  if (error) {
    return (
      <div style={{ padding: 20, fontFamily: 'sans-serif', color: 'crimson' }}>
        <h2>Something went wrong</h2>
        <pre>{error}</pre>
      </div>
    );
  }
    */
   const me = useMe();

  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h1>Hi {me.first_name} {me.last_name} 👋</h1>
      <p><strong>Email:</strong> {me.email}</p>
      <p><strong>Active org:</strong> {me.active_org_id || '(none resolved)'}</p>

      <h3>Your memberships</h3>
      <ul>
        {me.memberships.map((m) => (
          <li key={m.org_id}>
            <strong>{m.org_name}</strong> — {m.roles.join(', ')}
          </li>
        ))}
      </ul>

      <details style={{ marginTop: 24 }}>
        <summary>Raw /me response (debug)</summary>
        <pre style={{ background: '#f4f4f4', padding: 12, fontSize: 12 }}>
          {JSON.stringify(me, null, 2)}
        </pre>
      </details>
    </div>
  );
}